module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BL - Saint Barthélemy.8f602430.svg";